import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Full width on small screens; centred `container` from the `sm` breakpoint up (matches Tailwind theme). */
export function DashboardContentContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'w-full min-w-0 px-3 sm:container sm:mx-auto sm:px-5 md:px-6',
        className
      )}
    >
      {children}
    </div>
  );
}

/** Same as {@link DashboardContentContainer} but with wider horizontal padding on large screens (e.g. announcements). */
export function WideDashboardContentContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'w-full min-w-0 px-3 sm:container sm:mx-auto sm:px-5 md:px-8 lg:px-10',
        className
      )}
    >
      {children}
    </div>
  );
}
